export default __webpack_public_path__ + "static/media/galerie4.78fa0963.jpg";